var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossChain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_946",
    "data-name": "Group 946",
    transform: "translate(-468 -2891)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1170",
    "data-name": "Rectangle 1170",
    width: 102,
    height: 102,
    transform: "translate(468 2891)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Cross-chain_support",
    "data-name": "Cross-chain support",
    transform: "translate(485.246 2901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M35.2,29.02,0,8.7V49.341L35.2,69.662,70.4,49.341V8.7Z",
    transform: "translate(0 11.622)",
    fill: "#42e8e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M0,49.343,35.2,69.664V29.022L0,8.7Z",
    transform: "translate(0 11.621)",
    fill: "#8ebdeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M15.068,29.02V69.664l35.2-20.323V8.7Z",
    transform: "translate(20.131 11.622)",
    fill: "#016dd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M35.2,0,0,20.319,35.2,40.642l35.2-20.321Z",
    transform: "translate(0 0)",
    fill: "#8ebdeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M35.2,29.02,0,8.7v1.764L35.2,30.784l35.2-20.321,0-1.764Z",
    transform: "translate(0 11.622)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossChain);
export default __webpack_public_path__ + "static/media/CrossChain.a9c295142e90c043b29090b58e8ccf10.svg";
export { ForwardRef as ReactComponent };